












import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "app-detalle",
  computed: {
    ...mapGetters({ item: "currentItem" })
  }
});
